import { menuCategoryAdapter, menuItemAdapter } from '@/redux/menu/schema'
import { injectedOmsApi } from '@/services/oms'
import { createSlice, EntityState } from '@reduxjs/toolkit'

type Nullable<T> = T | null

type PlainInfo<T> = {
  status: RequestState
  error?: Nullable<string>
  data: Nullable<T>
  categoryEntities: EntityState<Oms.MenuCategory, string>
  itemEntities: EntityState<Oms.MenuItem, string>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: PlainInfo<Oms.MenuCategory[]> = {
  status: 'none',
  data: [],
  error: null,
  categoryEntities: menuCategoryAdapter.getInitialState(),
  itemEntities: menuItemAdapter.getInitialState(),
}

export const menuSlice = createSlice({
  name: '@menu',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      injectedOmsApi.endpoints.getMenu.matchFulfilled,
      (state, action) => {
        state.status = 'fulfilled'
        state.data = action.payload.payload.tags
        if (action.payload.payload?.tags) {
          state.categoryEntities = menuCategoryAdapter.addMany(
            state.categoryEntities,
            action.payload.payload.tags
          )
          state.itemEntities = menuItemAdapter.addMany(
            state.itemEntities,
            action.payload.payload.tags.reduce(
              (arr, category) => [
                ...arr,
                ...category.items.map((item) => ({
                  ...item,
                  categoryId: category.id,
                })),
              ],
              [] as Oms.MenuItem[]
            )
          )
        }
      }
    )
  },
})
